import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"

import Button from "../../../common/Button"
import { assignCaseLiability, assignCaseMajorMed, assignCaseMedPayUM, assignCaseWorkersComp } from "../../../../lib/fetchApi"
import { notificationActions } from "../../../../store/notifications"
import { caseActions } from "../../../../store/case"
import { insuranceActions } from "../../../../store/insurance"

const AsignInsurance = ({folder}) => {
    const dispatch = useDispatch()
    const [isLoading, setIsLoading] = useState(false)
    const [disableButton, setDisableButton] = useState(false)
    
    const userToken = useSelector(state => state.user.token)

    const activeCase = useSelector(state => state.case.activeCase)

    const selectedOptions = useSelector(state => state.insurance.insuranceDataID)


    useEffect(() => {

        if (!selectedOptions || (selectedOptions && !selectedOptions.insurance_carrier_id)) {
            setDisableButton(true)
        } else {
            setDisableButton(false)
        }
    }, [selectedOptions])


    const asignHandler = async () => {

        if (selectedOptions && selectedOptions.insurance_carrier_id) {
            setIsLoading(true)

            try {
                // need to change api based on tab since Liabilities, Medpay, Um uses the same insurance api 

                if (folder == 'liabilities') {
                    let reqBody = {
                        insurance_carrier_id: selectedOptions.insurance_carrier_id,//required
                        location_id: selectedOptions.location_id,
                        adjuster_id: selectedOptions.adjuster_id 
                    }
                    const insurance = await assignCaseLiability(userToken, activeCase.case.id, reqBody)
        
                    if (insurance?.id) {
                        // dispatch(attorneyActions.setAssignedAttorney(attorney))
                        dispatch(caseActions.insertLiabilityInActiveCase(insurance))
        
                        dispatch(insuranceActions.setSearchResult(null))
                        dispatch(insuranceActions.setClearAsyncResults(true))
                        dispatch(insuranceActions.removeinsuranceDataID())
                    } else {
                        dispatch(notificationActions.setError(insurance))
                    }
                } 

                if (folder == 'mp_pip_um') {
                    const asignedItem = await assignCaseMedPayUM(userToken, activeCase.case.id, {
                        insurance_carrier_id: selectedOptions.insurance_carrier_id,//required
                        location_id: selectedOptions.location_id,
                        adjuster_id: selectedOptions.adjuster_id 
                    })

                    if (asignedItem?.id) {
                        // dispatch(attorneyActions.setAssignedAttorney(attorney))
                        dispatch(caseActions.insertMedPayUMInActiveCase(asignedItem))
        
                        dispatch(insuranceActions.setSearchResult(null))
                        dispatch(insuranceActions.setClearAsyncResults(true))
                        dispatch(insuranceActions.removeinsuranceDataID())
                    } else {
                        dispatch(notificationActions.setError(asignedItem))
                    }
                } 

                if (folder == 'major_meds') {
                    const asignedItem = await assignCaseMajorMed(userToken, activeCase.case.id, {
                        insurance_carrier_id: selectedOptions.insurance_carrier_id,//required
                        location_id: selectedOptions.location_id,
                        adjuster_id: selectedOptions.adjuster_id 
                    })

                    if (asignedItem?.id) {
                        // dispatch(attorneyActions.setAssignedAttorney(attorney))
                        dispatch(caseActions.insertMajorMedInActiveCase(asignedItem))
        
                        dispatch(insuranceActions.setSearchResult(null))
                        dispatch(insuranceActions.setClearAsyncResults(true))
                        dispatch(insuranceActions.removeinsuranceDataID())
                    } else {
                        dispatch(notificationActions.setError(asignedItem))
                    }
                } 

                if (folder == 'worker_comp') {
                    const asignedItem = await assignCaseWorkersComp(userToken, activeCase.case.id, {
                        insurance_carrier_id: selectedOptions.insurance_carrier_id,//required
                        location_id: selectedOptions.location_id,
                        adjuster_id: selectedOptions.adjuster_id 
                    }, dispatch)


                    dispatch(insuranceActions.setSearchResult(null))
                    dispatch(insuranceActions.setClearAsyncResults(true))
                    dispatch(insuranceActions.removeinsuranceDataID())
                } 
            } finally {
                setIsLoading(false)
            }
        } 
    }

    return <Button click={asignHandler} isDisabled={disableButton} isLoading={isLoading}><i className="ti ti-square-plus"></i>Assign</Button>
}

export default AsignInsurance